var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeline-approval-text",class:_vm.timeline,domProps:{"innerHTML":_vm._s(_vm.approval)}})}
var staticRenderFns = []

export { render, staticRenderFns }